// src/pages/income/env/total/incomeEnvTotalDraftConfig.js
// ✅ 수입데이터+수입기안 통합 작성 [2단계] — 환경/종합 사업의 config.
// 종류는 EnvTotalIncome 실사용(68건) 근거: 냉난방기 종합세척이 54건(80%)으로
// 압도적이라 유일한 전용 종류로 두고(상세내역 표 필요), 나머지 7종(1~6건씩)은
// "기타"(자유입력)로 통합 — DocumentTypeSelector.jsx의 기존 DETAIL_OPTIONS
// (대금청구/개인고객 대금청구/기성계/완수계/준공계 5종)는 실사용과 무관해 채택하지 않음.
import { makeIncomeDraftConfig } from "../../_shared/incomeDraftConfig";
import AircondDetailPanel from "./AircondDetailPanel";

const CATEGORIES = [
  { value: "냉난방기 종합세척", label: "냉난방기 종합세척" },
];

const incomeEnvTotalDraftConfig = makeIncomeDraftConfig({
  namespace: "income-env-total-draft",
  category: "환경/종합",
  businessLabel: "환경/종합",
  tabTitle: "종합",
  // ✅ (구) 페이지가 실제로 쓰는 EnvTotalIncome.draft_no 접두어와 동일(실측:
  // env_total/views_api.py create()의 "금천일자리(주)환경/종합-").
  draftNoPrefix: "금천일자리(주)환경/종합",
  dataApiBase: "/env-total-incomes/",
  combinedCreateApi: "/env-total-incomes/draft/",
  newRoutePath: "/income/env/total/draft/new",
  listRoutePath: "/income/env/total/draft/list",
  previewRoutePath: "/income/env/total/draft/preview",
  categories: CATEGORIES,
  // ✅ 환경/종합도 경영팀과 동일하게 income.models.Partner(간이 거래처 모델) 사용.
  partnerApiBase: "/partners/",
  DetailPanel: AircondDetailPanel,
  detailPanelCategories: ["냉난방기 종합세척"],
  detailPanelPayloadKey: "aircond_details",
});

export default incomeEnvTotalDraftConfig;
